<template>
    <div >
        <div class="prop-title">
            {{ title }}
        </div>
        <div style="width:100%;height: 1px;background-color: lightgray;"></div>
    </div>

</template>
  
<script>
export default {
    name: 'PropHeader',
    props: ['title']
}
</script>
  
<style scoped>
.prop-title {
    /* background-color: #2c3e50; */
    padding: 15px;
    color: black;
    font-weight: bold;
    font-size: large;
}
</style>
  